"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var RadioGroupState_1 = require("./RadioGroupState");
var styles = require("./RadioGroup.css");
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new RadioGroupState_1.default({
            selected: props.data.defaultChecked || '',
        });
        _this.radioItemProps = _this.getInitialRadioItemProps();
        _this.renderChildren = _this.renderChildren.bind(_this);
        _this.getCustomClassNames = _this.getCustomClassNames.bind(_this);
        return _this;
    }
    RadioGroup.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.data.selected && newProps.data.selected !== this.state.selected) {
            this.setState({ selected: newProps.data.selected });
        }
    };
    RadioGroup.prototype.renderChildren = function () {
        var _this = this;
        return React.Children.map(this.props.children, function (child) {
            return React.cloneElement(child, __assign(__assign({}, _this.radioItemProps), { selected: _this.state.selected === child.props.data.value }));
        });
    };
    RadioGroup.prototype.handleChange = function (event) {
        var _this = this;
        this.setState({ selected: event.currentTarget.value }, function () {
            _this.props.events.onChange(_this.state.selected);
        });
    };
    RadioGroup.prototype.handleKeyPress = function (value) {
        var _this = this;
        this.setState({ selected: value }, function () {
            _this.props.events.onChange(_this.state.selected);
        });
    };
    RadioGroup.prototype.render = function () {
        var elementsDirection;
        switch (this.props.options && this.props.options.elementsDirection) {
            case 'column':
                elementsDirection = styles.containerColumn;
                break;
            default:
                elementsDirection = styles.containerRow;
        }
        return (React.createElement("div", { "data-test-id": this.props.testId, className: [styles.radioGroupContainer,
                elementsDirection, this.getCustomClassNames()].join(' ') }, this.renderChildren()));
    };
    RadioGroup.prototype.getCustomClassNames = function () {
        if (this.props.options && this.props.options.className) {
            return this.props.options.className;
        }
        return '';
    };
    RadioGroup.prototype.getInitialRadioItemProps = function () {
        var accordion = this.props.options && this.props.options.accordion;
        var className = this.props.options && this.props.options.className;
        var type;
        if (this.props.options && this.props.options.tabType) {
            type = this.props.options.tabType;
        }
        return {
            accordion: accordion,
            className: className,
            events: {
                onChange: this.handleChange.bind(this),
                onKeyPress: this.handleKeyPress.bind(this),
            },
            name: this.props.data.name,
            type: type,
        };
    };
    return RadioGroup;
}(React.Component));
exports.default = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RadioGroup/RadioGroup.js
// module id = 1224
// module chunks = 8